<div class="module general">
  <!-- Si el paquete se encuentra rechazado incluir el motivo-->
  @if (isRejected()) {
    <div class="rejected">
      <h3>Motivo del rechazo</h3>
      <p>
        {{ getCommentToRejected() }}
      </p>
    </div>
  }

  <!-- Si se está editando un paquete ya aprobado mostrar la siguiente nota-->
  @if (isApproved()) {
    <div class="note">
      <p>
        Si necesita modificar datos sensibles de este Paquete Financiero deberá crear una nueva versión desde la página
        anterior.
      </p>
    </div>
  }
  <h2>Información general</h2>
  <form action="" [formGroup]="form">
    <div class="wrapperG4">
      <div class="controlWrapper x2">
        <label>
          {{ 'financial-setup.form.name' | translate }}
          <span class="required">*</span></label
        >
        <input type="text" formControlName="financialSetupName" />
      </div>

      <div class="controlWrapper x2">
        <label>
          {{ 'financial-setup.form.description' | translate }}
          <span class="required">*</span></label
        >
        <input type="text" formControlName="financialSetupDescription" />
      </div>
      @if (isApproved()) {
        <label class="switch gapTop">
          <input type="checkbox" checked formControlName="active" />
          <span class="knob"></span>
          <span class="base"></span>
          <span class="description">Vigente</span>
        </label>
      }
    </div>

    <div class="divider"></div>
    <div class="wrapperG4">
      <div class="controlWrapper">
        <label>Producto financiero<span class="required">*</span></label>
        <div class="customSelect">
          <select
            formControlName="financialProduct"
            [disabled]="shouldDisableFields()"
            (change)="onChangeFinancialProduct($event)"
          >
            @for (product of financialProductsFiltered(); track product) {
              <option [value]="product.value">{{ product.name }}</option>
            }
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <label>Moneda<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="currency" [disabled]="shouldDisableFields()">
            @for (currency of currencies; track currency) {
              <option [value]="currency.value">{{ currency.type }}</option>
            }
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <label>Condición<span class="required">*</span></label>
        <div class="customSelect">
          <select
            formControlName="classification"
            (change)="onClassificationChange($event)"
            [disabled]="shouldDisableFields()"
          >
            <option [value]="true">Nuevo</option>
            <option [value]="false">Seminuevo</option>
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <label>Compañía<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="companyName" (change)="onChangeCompany($event)">
            @for (company of companyTypes; track company) {
              <option [value]="company.value">{{ company.display }}</option>
            }
          </select>
        </div>
      </div>
      @if (showFinancialSetupQuoteValidityDays) {
        <div class="controlWrapper">
          <label>Días de vigencia de cotización<span class="required">*</span></label>
          <div class="customSelect">
            <select formControlName="quoteValidityDays" [disabled]="shouldDisableFields()">
              <option [value]="15">15 días</option>
              <option [value]="30">30 días</option>
            </select>
          </div>
        </div>
      }
      <div class="controlWrapper">
        <label>Tipo de pago<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="paymentType">
            <option [value]="'PREPAID'">Anticipado</option>
            <option [value]="'EXPIRATION'">Vencido</option>
          </select>
        </div>
      </div>
      <div class="controlWrapper">
        <label>Forma de amortización<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="paymentFormationType">
            <option [value]="'LEVELED'">Nivelada</option>
          </select>
        </div>
      </div>

      <!-- Campo específico para:
          Crédito directo
          Arrendamiento financiero
          -->
      @if (isCreditDirect() || isFinancialLeasing() || isDCBalloon()) {
        <div class="controlWrapper">
          <label>Enganche<span class="required">*</span></label>
          <div class="customSelect">
            <select formControlName="downPaymentTaxType">
              @for (taxType of downPaymentTaxType; track taxType) {
                <option [value]="taxType.value">{{ taxType.display }}</option>
              }
            </select>
          </div>
        </div>

        @if (!isCreditDirect() && !isDCBalloon()) {
          <div class="controlWrapper">
            <label>Opción de compra<span class="required">*</span></label>
            <div class="customSelect">
              <select formControlName="purchaseOptionType">
                @for (taxType of downPaymentTaxType; track taxType) {
                  <option [value]="taxType.value">{{ taxType.display }}</option>
                }
              </select>
            </div>
          </div>
        }
      }

      <div class="controlWrapper">
        <label>Depósito en garantía<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="warrantyDeposit">
            @for (taxType of warrantyDepositType; track taxType) {
              <option [value]="taxType.value">
                {{ taxType.display }}
              </option>
            }
          </select>
        </div>
      </div>

      <div class="controlWrapper">
        <label>Comisión por apertura<span class="required">*</span></label>
        <div class="customSelect">
          <select formControlName="openingFeeType">
            @for (taxType of openingFeeType; track taxType) {
              <option [value]="taxType.value">
                {{ taxType.display }}
              </option>
            }
          </select>
        </div>
      </div>

      <!-- Campo específico para:
          Arrendamiento puro
          -->
      @if (iPureLease()) {
        <div class="controlWrapper">
          <label>Tipo de garantía<span class="required">*</span></label>
          <div class="customSelect">
            <select formControlName="warrantyType" (change)="onWarrantyTypeChange()">
              @for (taxType of warrantyTypes; track taxType) {
                <option [value]="taxType.value">{{ taxType.display }}</option>
              }
            </select>
          </div>
        </div>
      }

      <!-- Campo específico para:
          Arrendamiento puro
          -->
      @if (iPureLease()) {
        <div class="controlWrapper">
          <label>Valor residual<span class="required">*</span></label>

          <!-- Si es Garantía Daimler: mostrar texto fijo -->
          @if (form.get('warrantyType')?.value === 'DAIMLER') {
            <div class="value">
              <span>Monto Fijo Calculado</span>
            </div>
          } @else if (form.get('warrantyType')?.value === 'EXTERNAL') {
            <div class="customSelect">
              <select formControlName="residualValueType">
                @for (taxType of residualValueTypes; track taxType) {
                  <option [value]="taxType.value">{{ taxType.display }}</option>
                }
              </select>
            </div>
          }

          <!-- Si no hay garantía seleccionada: mostrar dropdown por defecto -->
          @if (!form.get('warrantyType')?.value) {
            <div class="customSelect">
              <select formControlName="residualValueType">
                @for (taxType of residualValueTypes; track taxType) {
                  <option [value]="taxType.value">{{ taxType.display }}</option>
                }
              </select>
            </div>
          }
        </div>
      }

      <!-- TODO:Mejorar para reactividad de estilos -->
      <div class="subsidio">
        <div class="controlWrapper">
          <label>Subsidio<span class="required">*</span></label>
          <div
            class="customSelect"
            [ngStyle]="{
              width:
                showPercentageInput(form.get('subsidyType')?.value) || showInput(form.get('subsidyType')?.value)
                  ? '100%'
                  : '100%',
            }"
          >
            <select formControlName="subsidyType" (change)="onChangeSubsidyType()">
              @for (taxType of subsidyTaxTypes; track taxType) {
                <option [value]="taxType.value">{{ taxType.display }}</option>
              }
            </select>
          </div>
        </div>
        <div class="controlWrapper">
          @if (showPercentageInput(form.get('subsidyType')?.value)) {
            <div><input type="number" style="width: 50px; margin-right: 5px" formControlName="subsidyValue" />%</div>
          } @else if (showInput(form.get('subsidyType')?.value)) {
            <div style="display: flex; flex-direction: row; align-items: center">
              <input
                type="number"
                id="display"
                style="display: none; width: 120px; margin-right: 5px"
                formControlName="subsidyValue"
                (blur)="hideAmountInput('display')"
                (keypress)="preventInvalidCharacters($event)"
              />

              <input
                id="hidden-display"
                type="text"
                style="display: block; width: 120px; margin-right: 5px"
                [value]="form.get('subsidyValue')?.value | currency: '' : '' : '0.0-8'"
                (focus)="showAmountInput('display')"
                readonly
              />

              <span class="currency">
                {{ form.get('currency')?.value ?? '$' }}
              </span>
            </div>
          }
        </div>
      </div>

      @if (isDCBalloon()) {
        <div class="balloon">
          <div class="controlWrapper">
            <label>Balloon<span class="required">*</span></label>
            <div
              class="customSelect"
              [ngStyle]="{
                width:
                  showPercentageInput(form.get('balloonType')?.value) || showInput(form.get('balloonType')?.value)
                    ? '100%'
                    : '100%',
              }"
            >
              <select formControlName="balloonType" (change)="onChangeBalloonType()">
                @for (taxType of balloonTaxTypes; track taxType) {
                  <option [value]="taxType.value">{{ taxType.display }}</option>
                }
              </select>
            </div>
          </div>
          <div class="controlWrapper">
            @if (showPercentageInput(form.get('balloonType')?.value)) {
              <div>
                <input type="number" style="width: 50px; margin-right: 5px" formControlName="balloonPercentage" />%
              </div>
            } @else if (showInput(form.get('balloonType')?.value)) {
              <div style="display: flex; flex-direction: row; align-items: center">
                <input
                  type="number"
                  id="displayB"
                  style="display: none; width: 120px; margin-right: 5px"
                  formControlName="balloonPercentage"
                  (blur)="hideAmountInput('displayB')"
                  (keypress)="preventInvalidCharacters($event)"
                />

                <input
                  id="hidden-displayB"
                  type="text"
                  style="display: block; width: 120px; margin-right: 5px"
                  [value]="form.get('balloonPercentage')?.value | currency: '' : '' : '0.0-8'"
                  (focus)="showAmountInput('displayB')"
                  readonly
                />

                <span class="currency">
                  {{ form.get('currency')?.value ?? '$' }}
                </span>
              </div>
            }
          </div>
        </div>
      }

      <!-- Campo específico para:
          Arrendamiento financiero
          Arrendamiento puro
          -->
      <!--      <div class="controlWrapper">
                <label>Gastos de ratificación<span class="required">*</span></label>
                <div class="customSelect">
                  <select formControlName="ratificationExpenses">
                    <option>Incluir</option>
                  </select>
                </div>
              </div>-->

      <!-- Campo específico para:
          Crédito directo
          -->

      <!-- @if (isCreditDirect()) {
        <div class="controlWrapper">
          <label>Colateral adicional<span class="required">*</span></label>
          <div class="customSelect">
            <select formControlName="additionalCollateral">
              @for (taxType of additionalCollateralTaxTypes; track taxType) {
                <option [value]="taxType.value">{{ taxType.display }}</option>
              }
            </select>
          </div>
        </div>
      } -->

      <!-- Campo específico para:
          Crédito directo con SOFOM
          -->
      @if (isCreditDirect() && (companyName() === 'SOFOM' || companyName() === 'BOTH')) {
        <div class="controlWrapper">
          <label for="taxFree">{{ 'VAT exempt' | translate }}</label>
          <div class="customSelect">
            <select id="taxFree" formControlName="taxFree">
              @for (option of taxFreeOptions; track option.value) {
                <option [value]="option.value">
                  {{ option.display }}
                </option>
              }
            </select>
          </div>
        </div>
      }
    </div>

    <div class="wrapperG2 preferences">
      <div>
        <h3>Preferencias</h3>
        <div class="wrapperG2">
          <div>
            <label class="checkboxWrapper">
              <input type="checkbox" formControlName="allowCapitalGrace" />
              <span class="checkmark"></span>
              <span class="description">Permitir gracia de capital</span>
            </label>
          </div>
          <div>
            <label class="checkboxWrapper">
              <input type="checkbox" formControlName="allowInterestGrace" />
              <span class="checkmark"></span>
              <span class="description">Permitir interés de gracia de capital</span>
            </label>
          </div>
        </div>
      </div>

      @if (featureLoyaltyFeriaQuotation) {
        <div>
          <h3>Tipo de paquete</h3>
          <div class="wrapperG2">
            <div>
              <label class="checkboxWrapper">
                <input type="checkbox" formControlName="loyaltyFinancialPackage" [disabled]="shouldDisableFields()" />
                <span class="checkmark"></span>
                <span class="description">Paquete Loyalty</span>
                <span class="loyaltyBadge" aria-hidden="true"
                  ><img src="./assets/images/icons/loyalty.svg" alt=""
                /></span>
              </label>
            </div>
          </div>
        </div>
      }
    </div>
    @if (hasPreferencesError()) {
      <div class="error-message" style="color: red; margin-top: 10px">
        Las preferencias no pueden estar vacías, ya que existen períodos de gracia ingresados.
      </div>
    }
  </form>
</div>
